import { NotificationCount } from "@ts-types/generated";
import Base from "./base";

class Notification extends Base<NotificationCount, NotificationCount> {

}

export default new Notification();
